import { AnyAction } from "redux";
import initialStore from "./initialStore";
import { ProjectActions } from "./actionsNames";

export default (store: IProjectStore = initialStore, action: AnyAction) => {
  switch (action.type) {
    case ProjectActions.SetForm:
      return {
        ...store,
        form: action.form,
      };
    case ProjectActions.SelectAttr:
      return {
        ...store,
        selectedAttributes: [
          ...store.selectedAttributes.filter(
              (a) => a.category != action.attr.category
          ),
          action.attr,
        ],
      };
    case ProjectActions.Reset:
      return {
        ...store,
        selectedAttributes: [],
        id: null,
      };
    case ProjectActions.InsertContent:
      return {
        ...store,
        contentLoading: false,
      };
    case ProjectActions.InsertAttributes:
      return {
        ...store,
        attributes: action.attributes,
      };
    case ProjectActions.InsertCart:
      return {
        ...store,
        cart: action.cart,
      };
    case ProjectActions.InsertProject:
      return {
        ...store,
        project: action.project,
      };
    case ProjectActions.InsertOrder:
      return {
        ...store,
        order: action.order,
      };
    case ProjectActions.ChangeAttrib:
      return {
        ...store,
        selectedAttributes: store.selectedAttributes.map((a) =>
            a.id === action.id ? { ...a, value: action.value } : a
        ),
        attributes: store.attributes.map((a) =>
            a.id === action.id ? { ...a, value: action.value } : a
        ),
      };
    case ProjectActions.InsertSelectedAttributes:
      return {
        ...store,
        selectedAttributes: action.attributes,
      };

    case ProjectActions.Center:
      return {
        ...store,
        centred: !store.centred,
      };
    case ProjectActions.SetZoom:
      return {
        ...store,
        zoom: action.zoom,
      };
    case ProjectActions.RemoveCart:
      return {
        ...store,
        cartId: null,
        cart: [],
      };
    case ProjectActions.LoadProject:
      return {
        ...store,
        date: action.project.date,
        id: action.project.id,
        selectedAttributes: action.project.components,
        editable: action.project.editable,
        loaded: true,
      };
    case ProjectActions.LoadHistory:
      return {
        ...store,
        history: action.history,
      };
    case ProjectActions.AddProjectToCart:
      return {
        ...store,
        cart: [
          ...store.cart.filter((c) => c.id !== action.project.id),
          action.project,
        ],
      };
    case ProjectActions.ChangeProjectCount:
      return {
        ...store,
        cart: [
          ...(store.cart as any).map((c: any) =>
              c.id !== action.id ? c : { ...c, count: action.count }
          ),
        ],
        loading: true,
      };
    case ProjectActions.DeleteCart:
      return {
        ...store,
        cart: [...store.cart.filter((c) => c.id !== action.id)],
      };
    case ProjectActions.LoadCart:
      return {
        ...store,
        cart: action.cart,
      };
    case ProjectActions.SetLoaded:
      return {
        ...store,
        loaded: action.loaded,
      };
    case ProjectActions.UpdateHistory:
      return {
        ...store,
        id: action.project.id,
        loaded: true,
        history: store.history.find((h) => h.id === action.project.id)
            ? [
              ...(store.history as any).map((h: any) =>
                  h.id !== action.project.id ? h : action.project
              ),
            ]
            : [...store.history, action.project],
      };
    case ProjectActions.UpdateCart:
      return {
        ...store,
        cartId: action.cart.id,
        cart: action.cart.projects,
        loading: false,
      };
    default:
      return store;
  }
};

export interface IProjectStore {
  form: IUserForm;
  attributes: IAttributes[];
  selectedAttributes: IAttributes[];
  contentLoading: boolean;
  project: any;
  zoom: number;
  centred: boolean;
  date: number | null;
  id: string | null;
  cartId: string | null;
  editable: boolean;
  cart: IProject[] | [];
  history: IProject[] | [];
  loaded: boolean;
  loading: boolean;
  order: any;
}

export interface IAttributes {
  id: number;
  name: string;
  price: string;
  category: AttributesType;
  description: string;
  placeholder: string;
  step: Steps;
  type: Types;
  pimg?: string;
  default?: number;
  value?: number;
  vimg?: string;
}

export interface IProject {
  id: string;
  components: IAttributes[];
  count: number;
  date: number;
  editable: boolean;
}

export interface IUserForm {
  name: string;
  email: string;
  phone: string;
  notes: string;
  agree: boolean;
  fastOrder: boolean;
}

export enum Types {
  Select = "select",
  Picker = "picker",
  Input = "input",
}

export enum Steps {
  ONE,
  TWO,
  THREE,
  FOUR,
}

export enum AttributesType {
  Size = "Size",
  OpenDirection = "open_direction",
  Jamb = "jamb",
  Closer = "closer",
  Handle = "handle",
  Vent = "vent",
  Color = "color",
  Ferrule = "ferrule",
  Count = "count",
}
